__turbopack_context__.v({
  "titleDescriptionItem": "TitleDescriptionItem-module-scss-module__0tyLAa__titleDescriptionItem",
});
